import { ShieldCheck, ExternalLink, X } from 'lucide-react';

export default function VerifyPopover({ open, onClose, txHash }) {
  if (!open) return null;

  return (
    <div className="absolute bottom-full right-0 mb-2 w-72 bg-white rounded-xl border border-slate-200 shadow-xl z-50 p-4" data-testid="verify-popover">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <ShieldCheck className="w-5 h-5 text-emerald-500" />
          <span className="font-semibold text-sm text-slate-900">On-Chain Verification</span>
        </div>
        <button onClick={onClose} className="w-6 h-6 rounded flex items-center justify-center hover:bg-slate-100"><X className="w-3.5 h-3.5 text-slate-400" /></button>
      </div>
      <div className="space-y-2">
        <div>
          <p className="text-[10px] text-slate-400 uppercase tracking-wider">Transaction Hash</p>
          <p className="text-xs font-mono text-slate-600 break-all">{txHash || '0x...'}</p>
        </div>
        <div>
          <p className="text-[10px] text-slate-400 uppercase tracking-wider">Status</p>
          <p className="text-xs text-emerald-600 font-medium flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> Verified on BNB Chain</p>
        </div>
        <div>
          <p className="text-[10px] text-slate-400 uppercase tracking-wider">Timestamp</p>
          <p className="text-xs text-slate-600">{new Date().toLocaleString()}</p>
        </div>
        <a href={`https://bscscan.com/tx/${txHash}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-xs font-medium text-[#7C3AED] hover:underline mt-2" data-testid="view-bscscan">
          View on BscScan <ExternalLink className="w-3 h-3" />
        </a>
      </div>
    </div>
  );
}
